import React, { useEffect, useRef } from 'react';

function DialogLectureTaskSampleText({ text }) {
    const contentRef = useRef(null);

    useEffect(() => {
        const paragraphs = contentRef.current.querySelectorAll('p');

        paragraphs.forEach((paragraph) => {
            paragraph.classList.toggle(
                'lecture-task-sample-text__image-pair',
                paragraph.querySelectorAll('img').length === 2
            );

            const headings = paragraph.querySelectorAll('strong');

            headings.forEach((heading) => {
                const titles = heading.textContent
                    .split(/(?:\u00a0\s*){3,}/)
                    .map((title) => title.trim())
                    .filter(Boolean);

                if (
                    paragraph.children.length !== 1 ||
                    paragraph.firstElementChild !== heading ||
                    titles.length !== 2
                ) {
                    return;
                }

                heading.classList.add('lecture-task-sample-text__heading-pair');
                heading.textContent = '';

                titles.forEach((title) => {
                    const column = document.createElement('span');
                    column.textContent = title;
                    heading.appendChild(column);
                });
            });
        });
    }, [text]);

    return (
        <div className="lecture-task-sample-text">
            <style>{`
                .lecture-task-sample-text {
                    color: #334155;
                    font-size: 0.9375rem;
                    line-height: 1.7;
                }
                .lecture-task-sample-text h1,
                .lecture-task-sample-text h2,
                .lecture-task-sample-text h3,
                .lecture-task-sample-text h4 {
                    color: #1e293b;
                    font-weight: 700;
                    line-height: 1.25;
                }
                .lecture-task-sample-text h1 {
                    font-size: 1.5rem;
                    margin: 2rem 0 0.75rem;
                }
                .lecture-task-sample-text h2 {
                    font-size: 1.3rem;
                    margin: 1.75rem 0 0.7rem;
                }
                .lecture-task-sample-text h3 {
                    font-size: 1.125rem;
                    margin: 1.5rem 0 0.6rem;
                }
                .lecture-task-sample-text h4 {
                    font-size: 1rem;
                    margin: 1.25rem 0 0.5rem;
                }
                .lecture-task-sample-text h1:first-child,
                .lecture-task-sample-text h2:first-child,
                .lecture-task-sample-text h3:first-child,
                .lecture-task-sample-text h4:first-child {
                    margin-top: 0;
                }
                .lecture-task-sample-text p {
                    margin: 0 0 1rem;
                }
                .lecture-task-sample-text ul,
                .lecture-task-sample-text ol {
                    margin: 0 0 1rem;
                    padding-left: 1.5rem;
                }
                .lecture-task-sample-text ul {
                    list-style-position: outside;
                    list-style-type: disc !important;
                }
                .lecture-task-sample-text ol {
                    list-style-position: outside;
                    list-style-type: decimal !important;
                }
                .lecture-task-sample-text ul ul {
                    list-style-type: circle !important;
                }
                .lecture-task-sample-text ol ol {
                    list-style-type: lower-alpha !important;
                }
                .lecture-task-sample-text li + li {
                    margin-top: 0.3rem;
                }
                .lecture-task-sample-text strong {
                    color: #1e293b;
                    font-weight: 700;
                }
                .lecture-task-sample-text__heading-pair {
                    display: grid;
                    gap: 1rem;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }
                .lecture-task-sample-text__heading-pair > span {
                    min-width: 0;
                    overflow-wrap: break-word;
                }
                .lecture-task-sample-text a {
                    color: #16a34a;
                    text-decoration: underline;
                    text-underline-offset: 2px;
                }
                .lecture-task-sample-text blockquote {
                    border-left: 3px solid #86efac;
                    color: #475569;
                    margin: 1.25rem 0;
                    padding: 0.25rem 0 0.25rem 1rem;
                }
                .lecture-task-sample-text img {
                    border-radius: 0.75rem;
                    display: block;
                    height: auto !important;
                    margin-top: 1.25rem;
                    margin-bottom: 1.25rem;
                    /* margin: 1.25rem auto; */
                    max-width: 100%;
                }
                .lecture-task-sample-text p > img:only-child {
                    margin: 1.25rem 0;
                }
                .lecture-task-sample-text__image-pair {
                    align-items: flex-start;
                    display: flex;
                    gap: 1rem;
                }
                .lecture-task-sample-text__image-pair img {
                    flex: 1 1 0;
                    margin: 1.25rem 0;
                    min-width: 0;
                    width: calc((100% - 1rem) / 2) !important;
                }
                @media (max-width: 480px) {
                    .lecture-task-sample-text__image-pair {
                        flex-direction: column;
                    }
                    .lecture-task-sample-text__image-pair img {
                        width: 100% !important;
                    }
                }
                .lecture-task-sample-text table {
                    border-collapse: collapse;
                    display: block;
                    margin: 1.25rem 0;
                    max-width: 100%;
                    overflow-x: auto;
                }
                .lecture-task-sample-text th,
                .lecture-task-sample-text td {
                    border: 1px solid #e2e8f0;
                    padding: 0.5rem 0.75rem;
                    text-align: left;
                }
                .lecture-task-sample-text th {
                    background: #f8fafc;
                    color: #1e293b;
                    font-weight: 700;
                }
            `}</style>
            <div ref={contentRef} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}

export default DialogLectureTaskSampleText;
